import "../item.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.Header ??= {};
window.AppointmentBooking.Wizard.Views.Header.MainMenu ??= {};

AppointmentBooking.Wizard.Views.Header.MainMenu.DoctorItem = class DoctorItem extends (
  AppointmentBooking.Wizard.Views.Header.MainMenu.Item
) {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
  }

  initialize() {
    super.initialize(...arguments);
    return this.listenTo(this.booking, "change:provider", this.render);
  }
};
AppointmentBooking.Wizard.Views.Header.MainMenu.DoctorItem.prototype.template = "header/main_menu/item/doctor";
AppointmentBooking.Wizard.Views.Header.MainMenu.DoctorItem.prototype.className =
  "appointment-booking-wizard-main-menu-doctor-item";
